import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "./AboutMeComponent.css";
import { StyledEngineProvider } from "@mui/material";

function AboutMeComponent({userInfo}) {
    return (
        <StyledEngineProvider injectFirst>
        <CssBaseline />
        <Container>
            <Box sx={{ width: "100%", height: "100%" }}>
                <h2 className="about-me-title">About Me</h2>
                <p className="about-me-paragraph">
                {userInfo ? userInfo.biodata : 'Loading...'}
                </p>
            </Box>
        </Container>
        </StyledEngineProvider>
    );

}

export default AboutMeComponent;